import MatchAnalysisOdds from "../MatchAnalysisOdds";

export default function OddsTab() {

  return (
    <div className="text-[var(--theme-text)] bg-[var(--theme-bg)]">
      <MatchAnalysisOdds />
    </div>
  );
}
